// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__r8Jpj","header":"MergedInvoice_header__2kxjq"};